import DocumentPage from "../../../../invoice/DocumentPage";
import { siiCreditNoteConfig } from "./config";

const SIICreditNote = () => <DocumentPage config={siiCreditNoteConfig} />;

export default SIICreditNote;
